import { styled, Table, Typography, TableCell as MuiTableCell } from "@mui/material";

export const Styled = {
    cellTextStyle: { fontSize: "0.8rem" },
    boldCellTextStyle: { fontWeight: "bold", fontSize: "0.8rem" },
    headerCellTextStyle: { fontWeight: "bold", fontSize: "0.85rem" },

    Table: styled(Table)({
        tableLayout: "fixed",
        marginBottom: "25px",
        minWidth: 1200,
        "& td": {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
        },
    }),

    ClickablePdfText: styled(Typography)({
        color: "primary.main",
        cursor: "pointer",
        fontSize: "0.8rem",
    }),

    HeaderKategoriCell: styled(MuiTableCell)({
        fontWeight: "bold",
        fontSize: "0.85rem",
        width: "15%",
    }),

    HeaderCommentPlaceholderCell: styled(MuiTableCell)({
        fontWeight: "bold",
        fontSize: "0.85rem",
        width: "15%",
    }),

    HeaderCell: styled(MuiTableCell)({
        fontWeight: "bold",
        fontSize: "0.85rem",
        width: "10%",
    }),

    DataCell: styled(MuiTableCell)({
        fontSize: "0.8rem",
    }),

    BoldDataCell: styled(MuiTableCell)({
        fontWeight: "bold",
        fontSize: "0.8rem",
    }),

    Chip: styled(Typography)(({ theme }) => ({
        display: "inline-block",
        padding: theme.spacing(0, 1),
        marginLeft: theme.spacing(1),
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.grey[200],
        fontSize: theme.typography.caption.fontSize,
    })),
};
